// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import Alpine from 'alpinejs'

// import tailwind into javascript
import "../stylesheets/application.scss"

Rails.start()
ActiveStorage.start()

window.Alpine = Alpine
Alpine.start()

window.swal = Swal


import './common'
import './pagination'
import './device_model_search'
import './device_model_select'
import './device_select'
import './zebra_browser_print'
import './label_printing'
import './intake_range_picker'

import axios from 'axios'
window.axios = axios

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
axios.defaults.headers.common['X-CSRF-Token'] = token;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';